//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from 'vuex';
import { BaseMenu, MenuItem } from 'components/base/menu';
import AnimatedRouterView from 'components/base/AnimatedRouterView';
import { modules } from 'src/store';
import { wait } from 'src/util/helper';
import MENU_ITEMS from './menu.hjson';

export default {
	name: 'DefaultLayout',
	components: {
		BaseMenu,
		MenuItem,
		AnimatedRouterView,
	},
	data: () => ({
		drawer: false,
		showMsgBanner: true,
		menuItems: null,
		adminOpen: false,
	}),
	computed: {
		...mapState('auth', ['currentUser']),
		...mapGetters('auth', ['isAdmin']),
		profileMenuAttrs() {
			if (this.$q.screen.width <= 925) return { color: 'dark' };

			return {
				'round': false,
				'dense': false,
				'class': 'no-border-radius',
				'icon': 'account_circle',
				'label': this.currentUser && this.currentUser.email,
				'noCaps': true,
				'iconRight': 'arrow_drop_down',
				'color': 'faded',
			};
		},
	},
	async created() {
		this.menuItems = this.createMenuItems();
		this.closeSubmenus(this.$route);
		try {
			await Promise.all(
				modules.map(m => this.$store.dispatch(`${m}/init`))
			);
		} catch (error) {
			console.error(error);
		}
	},
	mounted() {
		this.$router.afterEach(async (to) => {
			this.closeSubmenus(to);
			if (['Leads', 'Users', 'User'].includes(to.name)) {
				this.showMsgBanner = false;
				return;
			}

			await wait(1000);
			this.showMsgBanner = true;
		});
	},
	methods: {
		closeSubmenus(route) {
			this.menuItems.forEach((item) => {
				if (!item.submenu) return;

				item.open = item.submenu.some(
					subitem => route.path.includes(subitem.path)
				);
			});
		},
		createMenuItems() {
			const checkItem = (item) => {
				const route = this.$router.resolve(`/${item.path}`).resolved;

				if (route.meta && route.meta.checkStore) {
					if (route.meta.checkStore instanceof Array) {
						return route.meta.checkStore.every(
							checkStore => checkStore(this.$store) === true
						);
					}
					return route.meta.checkStore(this.$store) === true;
				}

				return true;
			};

			const items = [...MENU_ITEMS]
				.map((item) => {
					if (item.submenu) {
						item.open = false;
						item.submenu
							.map(item => checkItem(item) ? item : null)
							.filter(Boolean);
					}

					if (item.submenu && !item.submenu.length) return null;

					return checkItem(item) ? item : null;
				})
				.filter(Boolean);

			if (!this.$store.getters['auth/isSetupCompletedFirstPart']) {
				items.unshift({
					label: 'Setup fertigstellen',
					icon: 'error_outline',
					path: 'setup',
				});
			} else if (
				this.$store.state.auth.currentUser.subscriptionStatus === 'pendingOffer'
			) {
				if (this.$store.state.subscription.offer) {
					items.unshift({
						label: 'Setup fertigstellen',
						icon: 'error_outline',
						path: 'payment/offercheckout',
					});
				}
			} else if (!this.$store.getters['auth/isSetupCompleted']) {
				items.unshift({
					label: 'Setup fertigstellen',
					icon: 'error_outline',
					path: 'payment/packages',
				});
			}

			return items;
		},
		logout() {
			this.$store.dispatch('auth/logout');
			this.$router.push('/login');
		},
		adminLogout() {
			this.$store.dispatch('admin/logout');
		},
	},
};
